var _path, _g, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_723",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H14V14H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_723)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99958 12.8334C10.2215 12.8334 12.8333 10.2217 12.8333 7.00004C12.8333 3.77826 10.2215 1.16666 6.99958 1.16666C3.77756 1.16666 1.16577 3.77826 1.16577 7.00004C1.16577 10.2217 3.77756 12.8334 6.99958 12.8334ZM6.99958 14C3.1335 14 -0.000976562 10.8658 -0.000976562 7.00004C-0.000976562 3.13425 3.1335 0 6.99958 0C10.8656 0 14 3.13425 14 7.00004C14 10.8658 10.8656 14 6.99958 14Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87752 3C5.99118 3 5.28699 3.24519 4.77705 3.74725C4.25495 4.23764 4 4.90319 4 5.75547H5.28699C5.28699 5.24178 5.39626 4.8331 5.61477 4.5529C5.85765 4.22601 6.25829 4.06253 6.80464 4.06253C7.24169 4.06253 7.58169 4.17925 7.82451 4.41281C8.05522 4.6463 8.17659 4.96158 8.17659 5.37019C8.17659 5.67377 8.06731 5.95396 7.84882 6.22254L7.64241 6.44434C6.8896 7.08651 6.42823 7.56526 6.25829 7.89217C6.10045 8.19575 6.02757 8.56934 6.02757 9.00133V9.19983H7.32672V9.00133C7.32672 8.70945 7.38744 8.45263 7.52097 8.21907C7.63026 8.00895 7.80025 7.81045 8.01876 7.6236C8.60156 7.1449 8.94149 6.84132 9.05078 6.71291C9.34216 6.33932 9.5 5.86056 9.5 5.28847C9.5 4.58791 9.25718 4.02752 8.78365 3.61884C8.29804 3.19848 7.66667 3 6.87752 3ZM6.6711 9.83037C6.41614 9.83037 6.20974 9.90039 6.0519 10.0639C5.86972 10.2157 5.78476 10.4142 5.78476 10.6593C5.78476 10.8928 5.86972 11.0913 6.0519 11.2548C6.20974 11.4182 6.41614 11.5 6.6711 11.5C6.91391 11.5 7.13247 11.4182 7.31457 11.2664C7.48456 11.103 7.56954 10.9045 7.56954 10.6593C7.56954 10.4142 7.48456 10.2157 7.31457 10.0639C7.14456 9.90039 6.92607 9.83037 6.6711 9.83037Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.aba1e096b8779f731498dde7fccb1980.svg";
export { ForwardRef as ReactComponent };